import useToastStore from '@store/toastStore'

const TOAST_STYLES = {
  success: {
    bg: 'bg-cb-green/10 border-cb-green/30',
    icon: 'text-cb-green',
    path: 'M4.5 12.75l6 6 9-13.5',
  },
  error: {
    bg: 'bg-red-50 border-red-200',
    icon: 'text-red-500',
    path: 'M6 18L18 6M6 6l12 12',
  },
  warning: {
    bg: 'bg-amber-50 border-amber-200',
    icon: 'text-amber-500',
    path: 'M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z',
  },
  info: {
    bg: 'bg-cb-accent/5 border-cb-accent/20',
    icon: 'text-cb-accent-text',
    path: 'M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z',
  },
}

const ToastContainer = () => {
  const toasts = useToastStore((s) => s.toasts)
  const removeToast = useToastStore((s) => s.removeToast)

  if (toasts.length === 0) return null

  return (
    <div className="fixed bottom-4 right-4 z-[100] flex flex-col-reverse
      gap-2 max-w-sm"
    >
      {toasts.map((t) => {
        const style = TOAST_STYLES[t.type] || TOAST_STYLES.info
        return (
          <div
            key={t.id}
            className={`flex items-start gap-3 px-4 py-3 rounded-xl border
              shadow-lg backdrop-blur-sm animate-slide-in ${style.bg}`}
          >
            <svg
              className={`w-5 h-5 shrink-0 mt-0.5 ${style.icon}`}
              fill="none" viewBox="0 0 24 24" stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round" strokeLinejoin="round"
                d={style.path}
              />
            </svg>
            <p className="text-sm text-gray-800 flex-1">{t.message}</p>
            <button
              onClick={() => removeToast(t.id)}
              className="text-gray-500 hover:text-gray-600 shrink-0"
            >
              <svg
                className="w-4 h-4" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" strokeWidth={2}
              >
                <path
                  strokeLinecap="round" strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        )
      })}
    </div>
  )
}

export default ToastContainer
